var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMetamask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.2953 5.34766L26.3047 16.4814L29.0768 9.91263L41.2953 5.34766Z",
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.68945 5.34766L21.5595 16.5868L18.923 9.91263L6.68945 5.34766Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9026 31.1562L31.9102 37.273L40.4525 39.6233L42.9083 31.2918L35.9026 31.1562Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.10742 31.2918L7.5481 39.6233L16.0905 37.273L12.098 31.1562L5.10742 31.2918Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6089 20.8211L13.2285 24.4218L21.7106 24.7985L21.4093 15.6836L15.6089 20.8211Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3762 20.8211L26.5005 15.5781L26.3047 24.7985L34.7717 24.4218L32.3762 20.8211Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0898 37.2725L21.1821 34.7866L16.7829 31.3516L16.0898 37.2725Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8027 34.7866L31.9101 37.2725L31.202 31.3516L26.8027 34.7866Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9081 37.2749L26.8008 34.7891L27.2076 38.1186L27.1624 39.5198L31.9081 37.2749Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0898 37.2749L20.8356 39.5198L20.8055 38.1186L21.1821 34.7891L16.0898 37.2749Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9107 29.1527L16.6621 27.9022L19.6602 26.5312L20.9107 29.1527Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0742 29.1527L28.3247 26.5312L31.3379 27.9022L27.0742 29.1527Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0901 37.273L16.8133 31.1562L12.0977 31.2918L16.0901 37.273Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1855 31.1562L31.9087 37.273L35.9012 31.2918L31.1855 31.1562Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7717 24.4219L26.3047 24.7985L27.0881 29.1526L28.3386 26.5311L31.3518 27.9021L34.7717 24.4219Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6635 27.9021L19.6767 26.5311L20.9121 29.1526L21.7106 24.7985L13.2285 24.4219L16.6635 27.9021Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2285 24.4219L16.7841 31.3522L16.6635 27.9021L13.2285 24.4219Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3538 27.9021L31.2031 31.3522L34.7737 24.4219L31.3538 27.9021Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7106 24.7969L20.9121 29.1509L21.9065 34.2884L22.1324 27.5238L21.7106 24.7969Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3052 24.7969L25.8984 27.5087L26.0792 34.2884L27.0886 29.1509L26.3052 24.7969Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0875 29.1528L26.0781 34.2903L26.8013 34.7875L31.2005 31.3524L31.3512 27.9023L27.0875 29.1528Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6621 27.9023L16.7826 31.3524L21.1819 34.7875L21.905 34.2903L20.9107 29.1528L16.6621 27.9023Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1633 39.5183L27.2085 38.1171L26.8318 37.7857H21.152L20.8055 38.1171L20.8356 39.5183L16.0898 37.2734L17.7471 38.6294L21.1068 40.9646H26.877L30.2518 38.6294L31.9091 37.2734L27.1633 39.5183Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8029 34.7862L26.0797 34.2891H21.9065L21.1833 34.7862L20.8066 38.1158L21.1532 37.7844H26.833L27.2097 38.1158L26.8029 34.7862Z",
    fill: "#161616",
    stroke: "#161616",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9289 17.2045L43.2095 11.0576L41.2961 5.34766L26.8027 16.1047L32.3771 20.8203L40.2566 23.1254L42.0042 21.0915L41.2509 20.5492L42.4562 19.4494L41.5221 18.7262L42.7274 17.8072L41.9289 17.2045Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M4.79102 11.0576L6.07162 17.2045L5.25806 17.8072L6.46333 18.7262L5.54431 19.4494L6.74958 20.5492L5.99629 21.0915L7.72887 23.1254L15.6083 20.8203L21.1827 16.1047L6.68932 5.34766L4.79102 11.0576Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2558 23.1254L32.3763 20.8203L34.7718 24.4211L31.2012 31.3514L35.9017 31.2911H42.9074L40.2558 23.1254Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6084 20.8203L7.72889 23.1254L5.10742 31.2911H12.098L16.7835 31.3514L13.2279 24.4211L15.6084 20.8203Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3042 24.7992L26.8013 16.1062L29.0914 9.91406H18.9219L21.1818 16.1062L21.7091 24.7992L21.8899 27.5412L21.9049 34.2907H26.0782L26.1083 27.5412L26.3042 24.7992Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.5ef203cadaaadf1cd12e749b920ce8be.svg";
export { ForwardRef as ReactComponent };